// Category definitions for theme organization

export const categories = {
  english: {
    name: 'English Version',
    subcategories: [
      { id: 'fast-food', name: 'Fast Food / Quick Service', category: 'Fast Food' },
      { id: 'cafes', name: 'Cafes / Casual Dining', category: 'Cafes' },
      { id: 'premium', name: 'Premium Restaurants', category: 'Premium' },
      { id: 'youth', name: 'Youth-Oriented', category: 'Youth' },
      { id: 'family', name: 'Family Restaurants', category: 'Family' },
      { id: 'playful', name: 'Playful & Fun', category: 'Playful' },
      { id: 'modern', name: 'Modern & Tech', category: 'Modern' },
      { id: 'original', name: 'Original', category: 'Original' },
    ]
  },
  bangalore: {
    name: 'Bangalore Version',
    subcategories: [
      // By Area/Demographic
      { id: 'blr-tech-parks', name: '💼 Tech Parks (Whitefield, Marathahalli)', themeIds: [110, 115] },
      { id: 'blr-traditional', name: '🏛️ Traditional Areas (Jayanagar, Malleswaram)', themeIds: [101, 104, 107, 111] },
      { id: 'blr-cosmopolitan', name: '🌆 Cosmopolitan (Indiranagar, Koramangala)', themeIds: [103, 105, 108, 113] },
      { id: 'blr-student', name: '🎓 Student Areas (Near Colleges)', themeIds: [109, 112, 119] },
      { id: 'blr-family', name: '👨‍👩‍👧‍👦 Family Restaurants', themeIds: [106, 117, 118, 120] },
      // By Time/Mood
      { id: 'blr-morning', name: '🌅 Morning (Breakfast)', themeIds: [104, 111, 118] },
      { id: 'blr-lunch', name: '🍱 Lunch (Office Areas)', themeIds: [102, 110, 114, 115] },
      { id: 'blr-evening', name: '🌆 Evening/Dinner', themeIds: [105, 108, 112, 119] },
      { id: 'blr-weekend', name: '🎉 Weekend', themeIds: [106, 109, 119] },
      { id: 'blr-festivals', name: '🪔 Festivals (Dasara, Ugadi)', themeIds: [101, 107, 117] },
    ]
  },
  multilingual: {
    name: 'Multilingual',
    subcategories: [
      // By Language
      { id: 'tamil-all', name: '🔴 Tamil Themes', category: 'Tamil' },
      { id: 'malayalam-all', name: '🟢 Malayalam Themes', category: 'Malayalam' },
      { id: 'hindi-all', name: '🔶 Hindi Themes', category: 'Hindi' },
      { id: 'pan-india-all', name: '🌈 Pan-India Mix', category: 'Pan-India' },
      // By Bangalore Area (Tamil)
      { id: 'tamil-btm', name: '🔴 BTM Layout, JP Nagar (Tamil)', themeIds: [201, 202, 203, 204, 205] },
      // By Bangalore Area (Malayalam)
      { id: 'malayalam-marathahalli', name: '🟢 Marathahalli, Whitefield (Malayalam)', themeIds: [206, 207, 208, 209, 210] },
      // By Bangalore Area (Hindi)
      { id: 'hindi-north', name: '🔶 Yelahanka, Hebbal (Hindi)', themeIds: [211, 212, 213, 214, 215] },
      // By Bangalore Area (Mixed)
      { id: 'mixed-cosmopolitan', name: '🌈 Koramangala, HSR (Mixed)', themeIds: [216, 217, 218, 219, 220] },
    ]
  },
  ageWise: {
    name: 'Age-Wise Themes',
    subcategories: [
      // Tamil Age Groups
      { id: 'age-tamil-youth', name: '🔴 Tamil Youth (18-29)', themeIds: [301] },
      { id: 'age-tamil-adults', name: '🔴 Tamil Adults (30-45)', themeIds: [302] },
      { id: 'age-tamil-elders', name: '🔴 Tamil Elders (45+)', themeIds: [303] },
      { id: 'age-tamil-families', name: '🔴 Tamil Families', themeIds: [304] },
      { id: 'age-tamil-professional', name: '🔴 Tamil Professional', themeIds: [305] },
      // Malayalam Age Groups
      { id: 'age-malayalam-youth', name: '🟢 Malayalam Youth (18-29)', themeIds: [306] },
      { id: 'age-malayalam-adults', name: '🟢 Malayalam Adults (30-45)', themeIds: [307] },
      { id: 'age-malayalam-elders', name: '🟢 Malayalam Elders (45+)', themeIds: [308] },
      { id: 'age-malayalam-families', name: '🟢 Malayalam Families', themeIds: [309] },
      { id: 'age-malayalam-professional', name: '🟢 Malayalam Professional', themeIds: [310] },
      // Hindi Age Groups
      { id: 'age-hindi-youth', name: '🔶 Hindi Youth (18-29)', themeIds: [311] },
      { id: 'age-hindi-adults', name: '🔶 Hindi Adults (30-45)', themeIds: [312] },
      { id: 'age-hindi-elders', name: '🔶 Hindi Elders (45+)', themeIds: [313] },
      { id: 'age-hindi-families', name: '🔶 Hindi Families', themeIds: [314] },
      { id: 'age-hindi-professional', name: '🔶 Hindi Professional', themeIds: [315] },
      // Kannada Age Groups
      { id: 'age-kannada-youth', name: '🟡 Kannada Youth (18-29)', themeIds: [316] },
      { id: 'age-kannada-adults', name: '🟡 Kannada Adults (30-45)', themeIds: [317] },
      { id: 'age-kannada-elders', name: '🟡 Kannada Elders (45+)', themeIds: [318] },
      { id: 'age-kannada-families', name: '🟡 Kannada Families', themeIds: [319] },
      { id: 'age-kannada-professional', name: '🟡 Kannada Professional', themeIds: [320] },
    ]
  }
};

export default categories;
